<div class="container mt-6 w-full px-8 lg:px-16">
  @if (page(); as p) {
    <h1
      class="mt-20 mb-2 bg-clip-text text-5xl leading-tight text-transparent lg:text-8xl"
      style="
        background: linear-gradient(
          to right,
          #008b79 0%,
          #008c6c 27%,
          #169999 60%,
          #004365 100%
        );
        background-clip: text;
      "
    >
      {{ p.title }}
    </h1>

    @if (p.updatedAt) {
      <div class="mb-10 text-lg leading-normal font-normal text-neutral-500">
        {{
          'pages.page.lastUpdated'
            | translate: { date: (p.updatedAt | localizedDate) }
        }}
      </div>
    }

    <div class="mb-16 flex flex-col gap-y-4" [innerHTML]="contentHtml()"></div>
  }
</div>
